"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)({
  withExternalIcon: {
    display: 'inline-flex',
    alignItems: 'center'
  },
  disableStyles: {
    textDecoration: 'none',
    color: 'inherit'
  },
  externalIcon: {
    fontSize: 18,
    marginLeft: 4
  }
});
var _default = useStyles;
exports.default = _default;